import DownloadSvg from '../../../svg/download'

const bytesToMegaBytes = (bytes) => (bytes / (1024 * 1024)).toFixed(2)

export default function Downloadable({ url, size, fileType }) {
  return (
    <div className='wrapper flex flexDirectionColumn alignCenter justifyCenter'>
      <DownloadSvg />

      <span>
        {fileType}, {bytesToMegaBytes(size)}MB
      </span>

      <a href={url} download target='_blank' rel='noreferrer'>
        Download
      </a>

      <style jsx>{`
        .wrapper {
          width: 15rem;
          height: 10rem;

          :global(svg) {
            margin: 1rem 0 0;
            fill: var(--primary-color);
            height: 5rem;
            opacity: 0.5;
          }

          span {
            font-size: 1.4rem;
          }

          a {
            color: var(--primary-color);
            font-size: 1.6rem;
            font-weight: 600;
          }
        }
      `}</style>
    </div>
  )
}
